// extracted by mini-css-extract-plugin
export default {"root":"IiEfBuI_3I","icon":"IvdeZrIjlW","content":"mlfm3BEh8m"};